<template>
  <b-button
    variant="outline-danger"
    size="sm"
    class="px-1 py-0 mr-2"
    @click="onClickDesignMode"
    :title="trans('design_mode')"
    :disabled="busy"
  >
    <i class="fa fa-fw fa-edit"></i>
  </b-button>
</template>

<script>
  export default {
    props: {
      organization: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
      }
    },
    methods: {
      onClickDesignMode() {
        this.busy = true
        this.error = null
        const url = `/org/${this.organization.id}/design_mode`
        axios.post(url, {
          is_editing_microsite: !this.organization.is_editing_microsite
        })
        .then(response => {
          window.location.reload()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.toggleDesignMode = this
    },
  }
</script>